import { episodes } from "@/mocks/episodes";
import { characters } from "@/mocks/characters";
import { news } from "@/mocks/news";

export const getEpisodeById = (id?: string) => episodes.find((e) => e.id === id);
export const getCharacterById = (id?: string) => characters.find((c) => c.id === id);
export const getNewsById = (id?: string) => news.find((n) => n.id === id);

export interface SearchResult {
  type: "剧情" | "角色" | "资讯";
  id: string;
  title: string;
  desc: string;
  link: string;
}

export const searchContent = (keyword: string): SearchResult[] => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  const results: SearchResult[] = [];

  episodes.forEach((e) => {
    if (
      e.title.toLowerCase().includes(kw) ||
      e.summary.toLowerCase().includes(kw) ||
      `第${e.number}集`.includes(kw)
    ) {
      results.push({
        type: "剧情",
        id: e.id,
        title: `第 ${e.number} 集 · ${e.title}`,
        desc: e.summary,
        link: `/detail/episode/${e.id}`,
      });
    }
  });

  characters.forEach((c) => {
    if (
      c.name.toLowerCase().includes(kw) ||
      c.identity.toLowerCase().includes(kw) ||
      c.intro.toLowerCase().includes(kw)
    ) {
      results.push({
        type: "角色",
        id: c.id,
        title: c.name,
        desc: c.identity,
        link: `/detail/character/${c.id}`,
      });
    }
  });

  news.forEach((n) => {
    if (n.title.toLowerCase().includes(kw) || n.summary.toLowerCase().includes(kw)) {
      results.push({
        type: "资讯",
        id: n.id,
        title: n.title,
        desc: n.summary,
        link: `/detail/news/${n.id}`,
      });
    }
  });

  return results.slice(0, 12);
};

export const relatedEpisodes = (currentId: string, characterIds: string[] = []) =>
  episodes
    .filter((e) => e.id !== currentId)
    .map((e) => ({
      episode: e,
      score: e.characterIds.filter((id) => characterIds.includes(id)).length,
    }))
    .sort((a, b) => b.score - a.score)
    .slice(0, 3)
    .map((x) => x.episode);

export const relatedNewsByTags = (currentId: string, tags: string[] = []) =>
  news
    .filter((n) => n.id !== currentId)
    .map((n) => ({ article: n, score: tags.includes(n.tag) ? 1 : 0 }))
    .sort((a, b) => b.score - a.score)
    .slice(0, 3)
    .map((x) => x.article);

export const episodesOfCharacter = (episodeIds: string[] = []) =>
  episodes.filter((e) => episodeIds.includes(e.id));

export const newsOfCharacter = (newsIds: string[] = []) =>
  news.filter((n) => newsIds.includes(n.id));

export const charactersOfEpisode = (characterIds: string[] = []) =>
  characters.filter((c) => characterIds.includes(c.id));